module.exports = __webpack_public_path__ + "media/images/amenities_icons/event-246e372ba841dc1aae15375eb69df933.svg";